import './style/index.less';
import MemberCard from './MemberCard';

export default MemberCard;
